import React, { useEffect, useMemo } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import { useInstData } from '../../hooks'
import ManagerInner from './ManagerInner'

const mapStateToProps = ({ loginInfo: { roles } }) => ({ roles, })

const Manager = connect(mapStateToProps)(({ config: configProps, dispatch, history, location: { search = '', pathname }, match, roles, ...props }) => {
	const { me, setState, me: { configs, tabs, allTabs, tabCounts } } = useInstData(props, useMemo(() => {
		let configs = typeof configProps === 'function' ? configProps({ roles }) : configProps
		configs = configs.tabs || { '': configs }
		configs = { ...configs }
		for (const tab in configs) {
			const config = configs[tab] = { ...configs[tab] }
			if (typeof config.disabled == 'function' ? config.disabled() : config.disabled) {
				delete configs[tab]
				continue
			}

			config.export = typeof config.export == 'function' ? config.export() : config.export
			config.pivot = typeof config.pivot == 'function' ? config.pivot() : config.pivot
			config.show = typeof config.show == 'function' ? config.show() : config.show
		}

		const allTabs = Object.keys(configs)


		return { configs, allTabs, tabs: allTabs.length > 1 ? configs : null, state: {} }
	}, []))

	const [, tabInUrl = ''] = decodeURIComponent(search).split('?')

	const tabName = configs[tabInUrl] ? tabInUrl : allTabs[0]

	const setTabCounts = v => me.tabCounts = v

	return tabName != tabInUrl
		? <Redirect to={`${pathname}${tabName ? `?${encodeURIComponent(tabName)}` : ''}`} />
		: <ManagerInner key={tabName} {...{
			config: configs[tabName], history, pathname,
			tabs, tabName, tabCounts, setTabCounts,
			...props
		}} />
})

export default Manager
